import { useDevOnly } from '@/composables/useDevOnly';

const devOnlyGuard = () => {
    const { isDev } = useDevOnly();
    if (!isDev()) return { name: 'home' };
};

// Routes nested inside DefaultLayout — inherit sidebar + top nav.
export default [
    {
        path: 'labs',
        name: 'labs',
        component: () => import('../views/LabsPage.vue'),
        beforeEnter: devOnlyGuard,
    },
];

// Top-level standalone route — no DefaultLayout wrapper. Used by the popup
// PDF viewer window so it renders full-screen with just our toolbar + iframe,
// not the whole Fresh chrome (sidebar, top nav, notification store, etc.).
export const labsStandalone = [
    {
        path: '/labs/viewer/:kind/:id',
        name: 'labs-viewer',
        component: () => import('../views/LabsPdfViewerPage.vue'),
        beforeEnter: devOnlyGuard,
    },
];
